"use strict";

import { UserDataAdapter } from "../presentation/adpters/UserDataAdapter";
import {
    isPublicState,
    redirectAuthenticatedFromAuth,
    redirectUnauthenticatedToAuth,
    resolveRedirectWhenAccessDenied,
    shouldSignoutAnonimo,
    userCanAccessState
} from "../utils/route-access/route-access";

export default [
    "$transitions",
    "JWTService",
    ($transitions, JWTService) => {
        $transitions.onBefore({}, (transition) => {
            try {
                const user = new UserDataAdapter().user();
                if (user?._id) {
                    if (!userCanAccessState({ user, transition })) {
                        return resolveRedirectWhenAccessDenied({
                            user,
                            transition,
                            JWTService
                        });
                    }
                    if (
                        shouldSignoutAnonimo({
                            user,
                            transition
                        })
                    ) {
                        return JWTService.signout();
                    }
                    const redirectFromAuth = redirectAuthenticatedFromAuth({
                        user,
                        transition
                    });
                    if (redirectFromAuth) return redirectFromAuth;
                    return true;
                }
                if (isPublicState(transition.to().name)) return true;
                const redirectToAuth = redirectUnauthenticatedToAuth({
                    transition
                });
                if (redirectToAuth) return redirectToAuth;
            } catch (error) {
                console.error("Error Route Access", error);
                return transition.router.stateService.target(
                    "nucont.authentication"
                );
            }
        });
    }
];
